import React from "react";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const TraineesCountData = () => {

  const data = [
    {
      name: "Jan",
      uv: 12
    },
    {
      name: "Feb",
      uv: 8
    },
    {
      name: "Mar",
      uv: 18
    },
    {
      name: "Apr",
      uv: 12
    },
    {
      name: "May",
      uv: 10
    },
    {
      name: "June",
      uv: 4
    },
    {
      name: "July",
      uv: 8
    },
    {
      name: "Aug",
      uv: 16
    },
    {
      name: "Sep",
      uv: 12
    },
    {
      name: "Oct",
      uv: 8
    },
    {
      name: "Nov",
      uv: 6
    },
    {
      name: "Dec",
      uv: 4
    }
  ];

  return (
    <>
      <div className="header-flex">
        <div className="heading">
          <h2>No. of Trainees</h2>
        </div>
        <div className="selectDate">
          <input
            type="date"
            placeholder="Select Date"
            name="todaysScheduledTraining"
            id="todaysScheduledTraining"
            title="From"
          />
          <input
            type="date"
            placeholder="Select Date"
            name="todaysScheduledTraining"
            id="todaysScheduledTraining"
            title="To"
          />
        </div>
      </div>
      <div className="dataContent">
        <h2>Average No. of Trainees</h2>
        <ResponsiveContainer width="100%" height={250}>
          <AreaChart
            data={data}
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            {/* <CartesianGrid strokeDasharray="3 3" /> */}
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Area
              type="monotone"
              dataKey="uv"
              strokeWidth={3}
              stroke="rgb(var(--SecondaryColorHex))"
              fill="rgba(var(--SecondaryColorHex), 0.06)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default TraineesCountData;
